export const getDaysInMonth = (a: Date) => {
  const b = new Date(a);
  b.setMonth(b.getMonth() + 1);
  b.setDate(0);

  return b.getDate();
};
